module.exports = __webpack_public_path__ + "img/qrpatient.2e48c8f7.png";